var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mode === 'mobile')?_c('MobileLayerContainer',{attrs:{"pid":_vm.pid,"layers":_vm.currentLayer,"group-name":_vm.groupName}}):_c('ScreenLayerContainer',{attrs:{"pid":_vm.pid,"layers":_vm.currentLayer,"group-name":_vm.groupName}})}
var staticRenderFns = []

export { render, staticRenderFns }